import { initializeKeycloak } from '../utils/keycloakUtils';

const handleFetchErrors = async (response, fetchAccessToken) => {

    let responseData;

    if (!response.ok) {
      
      //console.log(response);
      try {
        responseData = await response.clone().json();  // Lê o corpo da resposta uma vez
      } catch (e) {
        console.error('Falha ao extrair mensagem de erro do JSON:', e);
      }

      switch (response.status) {
        case 401:
        case 403:
          sessionStorage.removeItem('token');
          sessionStorage.removeItem('token_keycloack');
          sessionStorage.removeItem('usuarioLogado');
          alert('Sua sessão expirou! Faça login novamente.');
          initializeKeycloak(); 
          
          break;

        case 500:
            alert('Erro interno do servidor');
            break;
        case 404:
            alert('Recurso não encontrado');
          break;
        default:
            alert('Erro desconhecido');
      }
      
      const errorMessage = responseData?.message || 'Erro ao processar a requisição';
      throw new Error(errorMessage);
    }
    else{
        return await response;
    }
};

export default handleFetchErrors;